import { GROWTH_UPGRADE_BUTTON_COMPONENT } from 'navigation-components/config';
import { useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useEffect } from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { GlobalToolbarButton, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import { RESPONSIVE_TOOLBAR } from '../../../constants/gates';
import { useIsUngated } from '../../../hooks/useIsUngated';
import useMedia from '../../../hooks/useMedia';
import { GROWTH_UPGRADE_BUTTON_ID, GROWTH_UPGRADE_BUTTON_RENDER_TO_ID } from '../constants';
import { BREAKPOINT_SMALL } from 'nav-meta/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GrowthUpgradeButton = ({
  shouldRender,
  onClick,
  itemName,
  additionalListItemStyles
}) => {
  const {
    isOpen
  } = useComponentState(GROWTH_UPGRADE_BUTTON_COMPONENT);
  const {
    toggle
  } = useToggleComponent(GROWTH_UPGRADE_BUTTON_COMPONENT);
  const responsiveToolbarEnabled = useIsUngated(RESPONSIVE_TOOLBAR);
  const isGridBreakpointSmall = useMedia(`screen and (max-width: ${BREAKPOINT_SMALL})`);
  useEffect(() => {
    const handleEvent = event => {
      const renderToElement = document.getElementById(GROWTH_UPGRADE_BUTTON_RENDER_TO_ID);
      const buttonElement = document.getElementById(GROWTH_UPGRADE_BUTTON_ID);
      if (event instanceof MouseEvent && renderToElement && !renderToElement.contains(event.target) && buttonElement && !buttonElement.contains(event.target) || event instanceof KeyboardEvent && event.key === 'Escape') {
        if (isOpen) {
          toggle();
        }
      }
    };
    document.addEventListener('mousedown', handleEvent);
    document.addEventListener('keydown', handleEvent);
    return () => {
      document.removeEventListener('mousedown', handleEvent);
      document.removeEventListener('keydown', handleEvent);
    };
  }, [isOpen, toggle]);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: `Global Toolbar - ${itemName}`,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GlobalToolbarButton, {
        "data-test-id": GROWTH_UPGRADE_BUTTON_ID,
        id: GROWTH_UPGRADE_BUTTON_ID,
        itemName: "Upgrade",
        iconName: ICON_NAMES.UPGRADE_ARROW,
        onClick: evt => {
          onClick(evt);
          toggle();
        },
        iconTextKey: isGridBreakpointSmall && responsiveToolbarEnabled ? undefined : 'nav.tooltips.upgrade',
        ariaLabelKey: "nav.tooltips.upgrade",
        additionalListItemStyles: additionalListItemStyles
      }), /*#__PURE__*/_jsx("div", {
        id: GROWTH_UPGRADE_BUTTON_RENDER_TO_ID
      })]
    })
  });
};